import axios from 'axios';

export const HcsAPI = axios.create({
  timeout: 30000,
});

export const formatEndpoint = (endpoint: string): string => {
  try {
    const url = new URL(endpoint);
    return `${url.origin}/v1/`;
  } catch (error) {
    return '';
  }
};
